module.exports = __webpack_public_path__ + "media/images/mailer/activation_customer/resonio/preview_de-b805fdda1d68e111258cb7de15202e82.gif";